const actions = {
  //- Sets the current apprentice
  setSelectedApplication({ commit }, application) {
    commit('SET_APPLICATION', application)
  },
  setApplicationCompany({ commit }, company) {
    commit('SET_APPLICATION_COMPANY', company)
  },
  setApplicationProfession({ commit }, profession) {
    commit('SET_APPLICATION_PROFESSION', profession)
  },
  setApplicationEmployee({ commit }, employee) {
    commit('SET_APPLICATION_EMPLOYEE', employee)
  },
  setApplicationCompanyEmployments({ commit }, companyEmployments) {
    commit('SET_APPLICATION_COMPANY_EMPLOYMENTS', companyEmployments)
  },
  setApplicationOrders({ commit }, orders) {
    commit('SET_APPLICATION_ORDERS', orders)
  },
  setApplicationDistanceEducations({ commit }, distanceEducations) {
    commit('SET_APPLICATION_DISTANCE_EDUCATIONS', distanceEducations)
  },
  setApplicationWorkplace({ commit }, workplace) {
    commit('SET_APPLICATION_WORKPLACE', workplace)
  },
  setApplicationDepartments({ commit }, departments) {
    commit('SET_APPLICATION_DEPARTMENTS', departments)
  },
  setApplicationDepartment({ commit }, department) {
    commit('SET_APPLICATION_DEPARTMENT', department)
  },
  updateSelectedApplication({ commit }, application) {
    commit('UPDATE_APPLICATION', application)
  }
}

export default actions
